import { 
// trackClickContributionsStatsBelowEdit,
trackClickContributionsStatsBelowToC, trackClickSignInBelowToC, 
// trackClickSignInInTooltip,
// trackDisplayTooltipImpression,
trackMouseOverContributionStatsBelowToC, } from 'pathfinder/modules/ArticleContributionStats/utils/tracking';
import { injectStyles } from 'pathfinder/modules/ArticleContributionStats/styles';
function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}
const createContributorUsers = (data) => {
    const mainClassName = 'article-contributions-stats';
    const contributedUsers = Object.assign(document.createElement('div'), { className: `${mainClassName}__users` });
    data['top_contributors']
        .reverse()
        .filter((contributor) => contributor.avatar)
        .slice(0, 3)
        .forEach((contributor) => {
        if (!contributor.avatar) {
            return;
        }
        const userElement = Object.assign(document.createElement('div'), { className: `${mainClassName}__user` });
        userElement.appendChild(Object.assign(document.createElement('img'), {
            className: 'wds-avatar',
            src: contributor.avatar,
            alt: contributor.name,
        }));
        contributedUsers.appendChild(userElement);
    });
    return contributedUsers;
};
const renderContributions = (mainContainerElement, data) => {
    const mainClassName = 'article-contributions-stats';
    /**
     * ContributedUsers
     */
    const contributedUsers = createContributorUsers(data);
    mainContainerElement.appendChild(contributedUsers);
    /**
     * Contributions number
     */
    const contributedStatsElement = Object.assign(document.createElement('div'), {
        className: `${mainClassName}__contributions-stats`,
        innerHTML: `<b>${data.article_contributions}</b><span> people contributed to this page</span>`,
    });
    mainContainerElement.appendChild(contributedStatsElement);
};
const renderStatsBelowToC = (data, tooltipHTMLContent, track, variant) => {
    const tocElement = document.querySelector('#toc');
    const firstHeader = document.querySelector('.mw-parser-output > h2, .mw-parser-output > h3');
    const mainContainer = Object.assign(document.createElement('div'), { className: 'article-contributions-stats-toc' });
    const statsWrapper = Object.assign(document.createElement('div'), {
        className: 'article-contributions-stats-toc__stats',
    });
    renderContributions(statsWrapper, data);
    mainContainer.appendChild(statsWrapper);
    statsWrapper.addEventListener('click', () => {
        trackClickContributionsStatsBelowToC(track, variant);
    });
    const signInRow = Object.assign(document.createElement('div'), {
        className: 'article-contributions-stats-toc__sign-in-row',
        innerHTML: tooltipHTMLContent,
    });
    mainContainer.appendChild(signInRow);
    mainContainer.addEventListener('mouseenter', function () {
        trackMouseOverContributionStatsBelowToC(track, variant);
    });
    if (tocElement) {
        insertAfter(tocElement, mainContainer);
    }
    else if (firstHeader) {
        firstHeader.parentNode.insertBefore(mainContainer, firstHeader);
    }
    else {
        return false;
    }
    const logInButton = document.getElementById('login-button-below-toc');
    logInButton &&
        logInButton.addEventListener('click', () => {
            trackClickSignInBelowToC(track, variant);
        });
    return true;
};
// const renderStatsBelowEdit = (
// 	parent: HTMLElement,
// 	data: ArticleDataStats,
// 	track: ModuleTrackingFunction,
// 	tooltipHTMLContent: (id: string) => string,
// 	variant: string,
// ) => {
// 	const wrapperId = 'article-contributions-stats';
// 	const mainClassName = 'article-contributions-stats';
// 	let wrapper = document.getElementById(wrapperId);
//
// 	if (wrapper) {
// 		wrapper.parentNode.removeChild(wrapper);
// 	}
//
// 	wrapper = document.createElement('div');
// 	wrapper.setAttribute('id', wrapperId);
// 	wrapper.className = 'article-contributions-wrapper';
//
// 	const mainContainerElement = Object.assign(document.createElement('div'), { className: mainClassName });
//
// 	renderContributions(mainContainerElement, data);
// 	wrapper.appendChild(mainContainerElement);
// 	parent.appendChild(wrapper);
//
// 	const tooltip = Object.assign(document.createElement('div'), {
// 		className: `${mainClassName}__tooltip`,
// 		innerHTML: tooltipHTMLContent('tooltip-login-button'),
// 	});
//
// 	mainContainerElement.appendChild(tooltip);
//
// 	const loginButton = document.getElementById('tooltip-login-button');
// 	if (loginButton) {
// 		loginButton.addEventListener('click', () => {
// 			trackClickSignInInTooltip(track, variant);
// 		});
// 	}
//
// 	const hoverClass = `${mainClassName}__tooltip--force-display`;
//
// 	mainContainerElement.addEventListener('mouseenter', function () {
// 		tooltip.classList.add(hoverClass);
// 		trackDisplayTooltipImpression(track, variant);
// 	});
//
// 	mainContainerElement.addEventListener('mouseleave', () => {
// 		tooltip.classList.remove(hoverClass);
// 	});
//
// 	mainContainerElement.addEventListener('click', () => {
// 		trackClickContributionsStatsBelowEdit(track);
// 	});
// };
export function renderStats(parent, data, track, variant) {
    const articleLink = new URL(window.location.href);
    const loginLink = `https://auth.fandom.com/register?redirect=${encodeURIComponent(articleLink.toString())}`;
    const tooltipHTMLContent = (loginId) => `
<p>${window.mw.config.get('wgSiteName')} is made by people like you. <a href="${loginLink}" id="${loginId}">Sign In</a> and help us grow this community!
  `;
    injectStyles();
    return renderStatsBelowToC(data, tooltipHTMLContent('login-button-below-toc'), track, variant);
}
